var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute left-0 bottom-0 top-0 pa4 flex flex-column justify-between"},[(_vm.navigation)?_c('NavSidebar',{attrs:{"brand":_vm.development.brand,"items":_vm.navigation,"title":"About"}}):_vm._e(),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }